import React from 'react';
import { FormikProps, withFormik } from 'formik';

import { Contact } from '@/types/contact';
import { contactSchema } from '@/services/validators/contact';
import { FormContents, Values } from './ContactForm/FormContents';

export type OuterProps = {
  contact: Contact;
  isConnecting: boolean;
  onSubmit: (contact: Contact) => void;
};

export const ContactForm = withFormik<OuterProps, Values>({
  mapPropsToValues: ({ contact }) => contact,
  validationSchema: contactSchema,
  handleSubmit: (values, { props }) => {
    // trimの処理をapi通信側によせたい
    const contact: Contact = {
      id: values.id,
      organizationId: values.organizationId,
      corporationName: values.corporationName.trim(),
      departmentName: values.departmentName.trim(),
      postalCode: values.postalCode?.trim(),
      address: values.address?.trim(),
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
      kanaFirstName: values.kanaFirstName.trim(),
      kanaLastName: values.kanaLastName.trim(),
      phoneNumber: values.phoneNumber.trim(),
      email: values.email.trim(),
    };
    props.onSubmit(contact);
  },
})(
  // enhanced form
  ({
    errors,
    handleSubmit,
    touched,
    values,
    isConnecting,
    setSubmitting,
    resetForm,
    setFieldTouched,
    handleChange,
  }: OuterProps & FormikProps<Values>) => {
    return (
      <FormContents
        errors={errors}
        handleSubmit={handleSubmit}
        touched={touched}
        values={values}
        isConnecting={isConnecting}
        setSubmitting={setSubmitting}
        resetForm={resetForm}
        setFieldTouched={setFieldTouched}
        handleChange={handleChange}
      />
    );
  },
);
